import {
  laptopMediumMax,
  largeTabletMax,
  mobileXLargeMax,
  mobileXXLargeMax,
  tabletMax,
} from '@propertypal/shared/src/constants/mediaQueries';
import FontAwesomeIcon from '@propertypal/web-ui/src/icons/FontAwesomeIcon';
import { Container as SelectInput } from '@propertypal/web-ui/src/inputs/SelectInput.style';
import { MAX_WIDTH } from '@propertypal/web-ui/src/layout/PageWrapper.style';
import styled from 'styled-components';
import { filterBreakpoint } from './SearchBar/SearchBar.style';

export const SearchTitleWrapper = styled.div`
  padding: 30px 20px 0;

  @media (${laptopMediumMax}) {
    padding: 15px 15px 0;
  }
`;

export const ListSearchTitleWrapper = styled.div`
  @media (${mobileXXLargeMax}) {
    padding: 0 15px;
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 30px;

  @media (${laptopMediumMax}) {
    flex-direction: column;
  }
`;

export const InfoContent = styled.div`
  max-width: ${MAX_WIDTH}px;
  display: flex;
  flex-direction: column;

  & > div {
    margin-top: 15px;
  }
`;

export const Title = styled.h1`
  font-size: 36px;
  margin-left: -2px;
  color: ${(props) => props.theme.textDark};

  @media (${mobileXLargeMax}) {
    font-size: 28px;
  }
`;

export const SideOptions = styled.div`
  display: flex;
  flex-direction: row;

  @media (${largeTabletMax}) {
    margin-top: 15px;

    ${SelectInput} {
      max-width: 200px;
    }
  }

  @media (${filterBreakpoint}) {
    ${SelectInput} {
      width: 100%;
      max-width: none;
    }
  }
`;

export const SaveSearchWrapper = styled.div`
  min-width: 200px;
  margin-right: 20px;

  @media (${filterBreakpoint}) {
    display: none;
  }
`;

export const CoOwnershipBanner = styled.div`
  position: relative;
  background-color: rgba(232, 58, 79, 0.1);
  border-radius: 4px;
  border: solid 1px #e83a4f;
  padding: 12px;
`;

export const CoOwnershipHide = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.white};
  padding: 4px 6px;
  background-color: #e83a4f;
  position: absolute;
  top: -10px;
  right: -10px;
  font-size: 20px;
  border-radius: 100%;
  cursor: pointer;
  transition: linear 150ms background-color;

  &:hover {
    background-color: ${({ theme }) => theme.buttonHover};
  }
`;

export const CoOwnershipBannerConent = styled.div`
  margin: 0 auto;
  max-width: 980px;
  display: flex;
  align-items: center;

  a {
    color: #e83a4f;
    text-decoration: underline;
    text-decoration-color: #e83a4f;
    font-weight: bold;
    transition: linear 150ms color;
    white-space: nowrap;

    &:hover {
      color: ${({ theme }) => theme.textDark};
      text-decoration-color: ${({ theme }) => theme.textDark};
    }
  }

  > :not(:last-child) {
    margin-right: 10px;
  }

  @media (${tabletMax}) {
    text-align: center;
    justify-content: center;
    .co-ownership-desktop {
      display: none;
    }
  }

  @media (${mobileXLargeMax}) {
    span {
      font-size: 13px;
    }

    > :not(:last-child) {
      margin-right: 6px;
    }

    img {
      max-width: 80px;
    }
  }
`;
